import { useAuthProtection } from "@/hooks/useAuthProtection";
import { AuthLoader } from "@/components/auth/AuthLoader";
import { AuthError } from "@/components/auth/AuthError";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: "admin" | "host" | "guest";
  isPublic?: boolean;
}

const ProtectedRoute = ({ children, requiredRole, isPublic = false }: ProtectedRouteProps) => {
  const { isLoading, error } = useAuthProtection({ requiredRole, isPublic });

  if (isLoading) {
    return <AuthLoader />;
  }

  if (error) {
    return <AuthError error={error} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;